import { type SxProps, Tab, Tabs, type Theme, useTheme } from "@mui/material";
import type { FC, SyntheticEvent } from "react";

interface NotificationCenterTabsProps {
	value: number;
	onChange: (event: SyntheticEvent, newValue: number) => void;
	tabs: { id: string; label: string }[];
}

const a11yProps = (index: number) => ({
	id: `nc-tab-${index}`,
	"aria-controls": `nc-tabpanel-${index}`,
});

const tabsSx = (theme: Theme): SxProps<Theme> => ({
	width: "100%",
	backgroundColor: theme.palette.common.white,
	minHeight: 44,
	"& .MuiTabs-indicator": {
		backgroundColor: theme.palette.secondary.main,
		height: 2,
	},
	"& .MuiTab-root": {
		minHeight: 44,
		fontSize: 14,
		fontWeight: 500,
		textTransform: "none",
		color: theme.palette.grey[500],
		paddingInline: 2,
		"&.Mui-selected": {
			color: theme.palette.secondary.main,
			fontWeight: 600,
		},
	},
});

export const NotificationCenterTabs: FC<NotificationCenterTabsProps> = ({
	value,
	onChange,
	tabs,
}) => {
	const theme = useTheme();

	return (
		<Tabs
			value={value}
			onChange={onChange}
			variant="fullWidth"
			sx={tabsSx(theme)}
		>
			{tabs.map((tab, index) => (
				<Tab key={tab.id} label={tab.label} {...a11yProps(index)} />
			))}
		</Tabs>
	);
};
